import { render, staticRenderFns } from "./ywhcPermission.vue?vue&type=template&id=1f208ef5&scoped=true"
import script from "./ywhcPermission.vue?vue&type=script&lang=js"
export * from "./ywhcPermission.vue?vue&type=script&lang=js"
import style0 from "./ywhcPermission.vue?vue&type=style&index=0&id=1f208ef5&prod&scoped=true&lang=css"
import style1 from "./ywhcPermission.vue?vue&type=style&index=1&id=1f208ef5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f208ef5",
  null
  
)

export default component.exports